import { useState } from 'react';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import EditIcon from '@mui/icons-material/Edit';
import Typography from '@mui/material/Typography';
import MDTypography from 'components/MDTypography';
import { AccordianContainer } from 'components/Ui/styled';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccordionDetails from '@mui/material/AccordionDetails';
import AccordionSummary from '@mui/material/AccordionSummary';
import StudentTrackerEditDialog from './StudentTrackerEditDialog';
import { TrackerRowContainer } from '../../ssaComponentStyled';

/* --------------------------------
   Column Row Component
-------------------------------- */

const TrackerColumnRow = ({
  column,
  tracker,
  columnData,
  handleOpenDialog,
}) => {
  const note = columnData?.note || '';
  const status = columnData?.status || 'Status not set';

  return (
    <TrackerRowContainer container spacing={2} alignItems="center">
      <Grid item xs={4}>
        <MDTypography variant="button" fontWeight="bold">
          {column}
        </MDTypography>
      </Grid>

      <Grid item xs={2}>
        <MDTypography variant="button">{status}</MDTypography>
      </Grid>

      <Grid item xs={4}>
        <MDTypography variant="button">{note}</MDTypography>
      </Grid>

      <Grid item xs={2} textAlign="end">
        <Button
          size="small"
          variant="outlined"
          startIcon={<EditIcon />}
          onClick={() => handleOpenDialog(tracker, column, columnData)}
        >
          Edit
        </Button>
      </Grid>
    </TrackerRowContainer>
  );
};

/* --------------------------------
   Tracker Accordion Component
-------------------------------- */

const TrackerAccordionItem = ({ tracker, handleOpenDialog }) => {
  return (
    <AccordianContainer>
      <AccordionSummary expandIcon={<ExpandMoreIcon />}>
        <Typography variant="h6" fontWeight="bold">
          {tracker?.name}
        </Typography>
      </AccordionSummary>

      <AccordionDetails>
        {tracker?.columns?.map((column) => (
          <TrackerColumnRow
            key={column}
            column={column}
            tracker={tracker}
            columnData={tracker?.data?.[column]}
            handleOpenDialog={handleOpenDialog}
          />
        ))}
      </AccordionDetails>
    </AccordianContainer>
  );
};

/* --------------------------------
   Main Component
-------------------------------- */

const StudentTrackersAccordion = ({
  trackers = [],
  fetchTrackerStudentData,
}) => {
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [selectedColumnData, setSelectedColumnData] = useState(null);

  const handleOpenDialog = (tracker, column, columnData) => {
    const { note, status, version } = columnData || {};
    const { trackerId, statusOptions } = tracker || {};

    setSelectedColumnData({
      column,
      trackerId,
      statusOptions,
      note: note || '',
      status: status || '',
      version: version || null,
    });

    setOpenEditDialog(true);
  };

  if (!trackers?.length) return null;

  return (
    <>
      <MDTypography
        variant="body3"
        component="span"
        fontWeight="bold"
        textTransform="capitalize"
      >
        📋 Student Trackers
      </MDTypography>
      {trackers?.map((tracker) => (
        <TrackerAccordionItem
          key={tracker?.trackerId}
          tracker={tracker}
          handleOpenDialog={handleOpenDialog}
        />
      ))}

      {openEditDialog && (
        <StudentTrackerEditDialog
          open={openEditDialog}
          setOpen={setOpenEditDialog}
          columnData={selectedColumnData}
          fetchTrackerStudentData={fetchTrackerStudentData}
        />
      )}
    </>
  );
};

export default StudentTrackersAccordion;
